var map = {
	"./icon-ding.svg": "078f",
	"./icon-fa.svg": "3301",
	"./icon-guan.svg": "9b56",
	"./icon-guanli.svg": "e09a",
	"./icon-kai.svg": "6ea5",
	"./icon-list.svg": "76143",
	"./icon-shouye.svg": "edb3",
	"./icon-tou.svg": "93ac",
	"./icon-yao.svg": "8ee76",
	"./icon-yi.svg": "df18",
	"./icon-zhao.svg": "f292",
	"./icon-zhedie.svg": "e789",
	"./icon-zhengshu.svg": "6ae6",
	"./icon-zi.svg": "18ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";